<template>
  <v-app class="auth-layout">
    <v-content>
      <router-view :key="$route.path"></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({}),
  methods: {},
}
</script>

<style>
.auth-layout {
  background: #f6f8fc;
}
.auth-layout .v-content,
.auth-layout .v-content__wrap {
  padding: 0 !important;
}
</style>
